import React, { useContext, useEffect } from 'react'
import { MultiSelect } from 'primereact/multiselect'
import storage from '../../services/stoage.service'
import utils from '../../utils'
import { textoAgendamento } from './textos'
import { unidadesTravadas } from './agendamentoRelatorio.utils'
import { SeguirUnidadeDoTopo } from '../lottus/seguir-unidade-do-topo'

/**
 * Editor do filtro de unidades ({ unidades: [{ id, value }] }) no AgendarRelatorioDialog. Sem unidade marcada, o
 * relatorio considera todas as da empresa (como na tela do DRE). Usuario de unidade unica so agenda a propria: o
 * seletor fica desabilitado e o filtro e forcado para ela (ver unidadesTravadas). No filtro salvo (PHOENIX-107) trava
 * tambem na unidade escolhida no topo.
 * campo: o nome do filtro ('unidades' no DRE, 'oid_unidade' na tela dinamica); label: rotulo proprio (opcional).
 */
export const EditorFiltrosUnidades = ({ filtros, onChange, campo = 'unidades', label }) => {
  const seguirTopo = useContext(SeguirUnidadeDoTopo)
  const travadas = unidadesTravadas(seguirTopo || storage.getUsuarioUnidadeUnica(), storage.getUnit())
  const opcoes = utils.convertArrayIdValueToIdLabel(utils.getListIdValuesUnidadeFromEmpresa(storage.getCompany()))
  const atuais = filtros[campo]

  useEffect(() => {
    // compara pela unidade, nao pelo texto: o mesmo id com outro rotulo nao e mudanca (na tela dinamica, mudar a
    // unidade limpa os filtros que dependem dela)
    if (!travadas) {
      return
    }
    const soADoUsuario = Array.isArray(atuais) && atuais.length === 1 && atuais[0].id === travadas[0].id
    if (!soADoUsuario) {
      onChange(campo, travadas)
    }
  }, [atuais]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="p-col-12">
      <label className="label">{label || textoAgendamento('unidade')}</label>
      <MultiSelect
        value={utils.convertArrayIdValueToIdLabel(travadas || atuais)}
        options={opcoes}
        optionLabel="label"
        dataKey="id"
        selectedItemsLabel={textoAgendamento('unidade.selecionadas')}
        disabled={Boolean(travadas)}
        onChange={(e) => onChange(campo, utils.convertArrayIdLabelToIdValue(e.value))}
      />
    </div>
  )
}
